export const getUnitByNumber = (unitNumber, units) =>
  units.find(({ number }) => number === unitNumber);

export const getFirstUnit = (units) => units.find(({ number }) => number > 0);
